<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <situacion-laboral-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
        
         <add-button v-if="$store.getters.hasPermission('SITUACIONLABORAL_CREATE')" @click="create"></add-button>
      
        <situacion-laboral-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <situacion-laboral-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <situacion-laboral-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <situacion-laboral-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import SituacionLaboralCreate from "../SituacionLaboralCreate";
    import SituacionLaboralUpdate from "../SituacionLaboralUpdate";
    import SituacionLaboralDelete from "../SituacionLaboralDelete";
    import SituacionLaboralShow from "../SituacionLaboralShow";
    import SituacionLaboralList from "../SituacionLaboralList";
    
     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "SituacionLaboralCrud",
        components: {
            CrudLayout, AddButton, Snackbar,
            SituacionLaboralCreate, 
            SituacionLaboralUpdate, 
            SituacionLaboralDelete, 
            SituacionLaboralShow,
            SituacionLaboralList
        },
        data() {
            return {
                title: 'cobrox.situacionLaboral.title',
                subtitle: 'cobrox.situacionLaboral.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>


